// extracted by mini-css-extract-plugin
export default {"price":"MenuItemPrice-module__price___2el3i"};